import { SponsorMessage } from '@/queries/community-feed/types';
import { trackMP } from '@/shared/mp';

import Card, { CardProps } from './Card';
import { CardHabitatLink } from './CardLink';

const SponsorCard = ({ messageWithMeta }: CardProps<SponsorMessage>) => {
  const { tier } = messageWithMeta.message;
  const tierName = tier === 3 ? 'Guardian' : tier === 2 ? 'Friend' : tier === 1 ? 'Helper' : 'Supporter';
  return (
    <Card messageWithMeta={messageWithMeta}>
      <p className="preflight preflight-p line-clamp-3">
        became a <strong>{tierName}</strong> of the{' '}
        <CardHabitatLink
          message={messageWithMeta.message}
          onClick={() => {
            trackMP('community-feed-clicked', {
              content: 'sponsor',
            });
          }}
        >
          {messageWithMeta.message.habitat.title} at the {messageWithMeta.message.zoo.name}
        </CardHabitatLink>
        , thanks!
      </p>
    </Card>
  );
};

export default SponsorCard;
